<div [formGroup]="form">
    <div class="form-group">
        <textarea rows="5" cols="30" pInputTextarea formControlName="comment" placeholder="{{ 'CORE.USER.COMMENT' | translate }}" [maxlength]="commentMaxLength"></textarea>
        <div class="d-flex flex-row justify-content-end">
            <span>{{ ((commentLength | async) || '0') + '/' + commentMaxLength }}</span>
        </div>
    </div>
    <div class="form-group" *ngIf="!(isGuestAccount$ | async)">
        <textarea
            rows="5"
            cols="30"
            pInputTextarea
            formControlName="accountingComment"
            placeholder="{{ 'CORE.ACCOUNTING.COMMENT' | translate }}"
            [maxlength]="accountingCommentMaxLength"
        ></textarea>
        <div class="d-flex flex-row justify-content-end">
            <span>{{ ((accountingCommentLength | async) || '0') + '/' + this.accountingCommentMaxLength }}</span>
        </div>
    </div>
</div>
